import { QueryClient } from '@tanstack/react-query';

/**
 * gcTime bumped to 24h so persisted entries survive long enough to
 * be useful when the user reopens the app after walking the
 * grounds. Stale rules still apply — the dashboard will refetch
 * after 30s once the network is reachable.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 24 * 60 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
